import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../Assets/images/logo-white.png";
import thumbnail from "../Assets/images/room/thumbnail/1.jpg";
import thumbnail2 from "../Assets/images/room/thumbnail/2.jpg";

function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  const [showHeader, setShowHeader] = useState(false);

  useEffect(() => {
    // Check if we're on /about or /contact
    const isAlwaysVisible =
      location.pathname === "/about" || location.pathname === "/contact";

    if (isAlwaysVisible) {
      // Always show the header, no scrolling logic
      setShowHeader(true);
      return;
    }

    // Otherwise, define the scroll listener inline to avoid stale references
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      console.log("currentScrollPos", currentScrollPos);

      // If scrolled >= 180px, show header; otherwise, hide it.
      if (currentScrollPos >= 700) {
        setShowHeader(true);
      } else {
        setShowHeader(false);
      }
    };

    // Attach the scroll listener
    window.addEventListener("scroll", handleScroll);

    // Run it once so the header is correct on initial load
    handleScroll();

    // Cleanup: remove the scroll listener if we leave the route
    return () => window.removeEventListener("scroll", handleScroll);
  }, [location.pathname]);

  return (
    <header className={`main-header ${showHeader ? "sticky" : "hidden"}`}>
      <div className="container">
        <div className="init-fix-header fl-wrap">
          <a
            onClick={() => navigate("/")}
            className="logo-holder"
            style={{ cursor: "pointer" }}
          >
            <img src={logo} alt="Logo" />
          </a>
          <div className="nav-holder main-menu">
            <nav>
              <ul>
                <li>
                  <a
                    onClick={() => navigate("/")}
                    className="link-button"
                    style={{ cursor: "pointer" }}
                  >
                    Home
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => navigate("/about")}
                    className="link-button"
                    style={{ cursor: "pointer" }}
                  >
                    About
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => navigate("/contact")}
                    className="link-button"
                    style={{ cursor: "pointer" }}
                  >
                    Contact
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          <div className="nav-button-wrap">
            <div className="nav-button">
              <span />
              <span />
              <span />
            </div>
          </div>

          <div className="share-wrapper isShare">
            <div className="share-container fl-wrap" />
          </div>

          {/* Wishlist example */}
          <div className="wish-list-wrap novis_cart">
            <div className="wish-list-close close_cart-init clwl_btn">
              <i className="fa-regular fa-xmark" />
            </div>
            <div className="wish-list-title">Your Wishlist</div>
            <div className="wish-list-container">
              <div className="wish-list-item fl-wrap">
                <div className="wish-list-img">
                  <a href="room-single.html">
                    <img src={thumbnail} alt="Room Thumbnail" />
                  </a>
                </div>
                <div className="wish-list-descr">
                  <h4>
                    <a href="room-single.html">Garden Family Room</a>
                  </h4>
                  <div className="wish-list-price">$129/Night</div>
                  <a href="room-single.html" className="wshil_link">
                    Book Now
                  </a>
                  <div className="clear-wishlist">
                    <i className="fa-regular fa-trash-can" />
                  </div>
                </div>
              </div>

              <div className="wish-list-item fl-wrap">
                <div className="wish-list-img">
                  <a href="room-single.html">
                    <img src={thumbnail2} alt="Room Thumbnail 2" />
                  </a>
                </div>
                <div className="wish-list-descr">
                  <h4>
                    <a href="room-single.html">Premium Panorama Room</a>
                  </h4>
                  <div className="wish-list-price">$230/Night</div>
                  <a href="room-single.html" className="wshil_link">
                    Book Now
                  </a>
                  <div className="clear-wishlist">
                    <i className="fa-regular fa-trash-can" />
                  </div>
                </div>
              </div>
            </div>
            <div className="wish-list-wrap-btns">
              <a href="#" className="wl_btn">
                Clear wishlist
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
